import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
@Component({

  selector: 'app-server-down',
  templateUrl: './server-down.component.html',
  styleUrls: ['./server-down.component.css']
})
export class ServerDownComponent {



  private flakes: any[] = [];
  private flakeCount = 400;
  private mX = -100;
  private mY = -100;
  private canvas!: HTMLCanvasElement;
  private ctx!: CanvasRenderingContext2D;

  ngAfterViewInit() {
    const canvasEl = document.getElementById('canvas');
    if (!canvasEl) {
      console.error('Canvas element not found!');
      return;
    }
    this.canvas = canvasEl as HTMLCanvasElement;
    const ctx = this.canvas.getContext('2d');
    if (!ctx) {
      console.error('Could not get 2D context');
      return;
    }
    this.ctx = ctx

    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;

    this.init();
  }

  private snow() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    for (const flake of this.flakes) {
      const x = this.mX;
      const y = this.mY;
      const minDist = 150;
      const x2 = flake.x;
      const y2 = flake.y;

      const dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y));
      const dx = x2 - x;
      const dy = y2 - y;

      if (dist < minDist) {
        const force = minDist / (dist * dist);
        const xcomp = (x - x2) / dist;
        const ycomp = (y - y2) / dist;
        const deltaV = force / 2;

        flake.velX -= deltaV * xcomp;
        flake.velY -= deltaV * ycomp;

      } else {
        flake.velX *= .98;
        if (flake.velY <= flake.speed) {
          flake.velY = flake.speed;
        }
        flake.velX += Math.cos(flake.step += .05) * flake.stepSize;
      }

      this.ctx.fillStyle = `rgba(255,255,255,${flake.opacity})`;
      flake.y += flake.velY;
      flake.x += flake.velX;

      if (flake.y >= this.canvas.height || flake.y <= 0 || flake.x >= this.canvas.width || flake.x <= 0) {
        this.reset(flake);
      }

      this.ctx.beginPath();
      this.ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);
      this.ctx.fill();
    }

    requestAnimationFrame(() => this.snow());
  }

  private reset(flake: any) {
    flake.x = Math.floor(Math.random() * this.canvas.width);
    flake.y = 0;
    flake.size = (Math.random() * 3) + 2;
    flake.speed = (Math.random() * 1) + 0.5;
    flake.velY = flake.speed;
    flake.velX = 0;
    flake.opacity = (Math.random() * 0.2) + 0.1;
  }

  private init() {
    for (let i = 0; i < this.flakeCount; i++) {
      const x = Math.floor(Math.random() * this.canvas.width);
      const y = Math.floor(Math.random() * this.canvas.height);
      const size = (Math.random() * 3) + 2;
      const speed = (Math.random() * 1) + 0.5;
      const opacity = (Math.random() * 0.2) + 0.1;

      this.flakes.push({
        speed: speed,
        velY: speed,
        velX: 0,
        x: x,
        y: y,
        size: size,
        stepSize: (Math.random()) / 30,
        step: 0,
        opacity: opacity
      });
    }

    this.snow();
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.mX = event.clientX;
    this.mY = event.clientY;
  }

  @HostListener('window:resize')
  onResize() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
  }


}

